import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../../../components/Layout"
import Header from "../../../components/Header"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import ThumbnailImage from "../../../images/thumbnails/asiaberlin.png"

export function Index() {
  return (
    <Layout
      title="Asia Berlin Tech Summit Innovation & Networking with Premagic AI Photos"
      description="Asia Berlin Summit boosted international tech networking by connecting European and Asian innovators using Premagic’s AI-powered event photo distribution."
      metaImage={ThumbnailImage}
      keywords={[
        "Asia Berlin case study, international tech summit, Europe Asia tech networking, Berlin tech conference, cross-border tech events, international startup events, Berlin innovation summit, Asia Europe tech bridge, international conference photos, global tech networking, Berlin startup ecosystem, tech diplomacy events, international innovation events, Europe Asia collaboration, Berlin tech community",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "Asia Berlin Summit", url: "/case-study/asiaberlin/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "Asia Berlin Tech Summit Innovation & Networking with Premagic AI Photos",
            "description": "Asia Berlin Summit boosted international tech networking by connecting European and Asian innovators using Premagic’s AI-powered event photo distribution.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-01-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.ASIABERLIN} />
    </Layout>
  )
}

export default Index
